export default __webpack_public_path__ + "static/media/IMG_4547-min.837e8cc2.JPG";